import Http from "@/api/http";
import {
  addDefaultParamsAndEncrypt,
  responseDataDecode,
  responseToError
} from "../interceptors";
import { CgRequestParams } from "../types/index";
import { UrlMap } from "@/api/cg/base/cg_const";
/**
 * 实例化Http类
 */
const http = new Http({});

/**
 * 通过拦截器处理返回的结果
 */
http.interceptors.response.use(
  res => responseToError(res),
  error => Promise.reject(error)
);

http.interceptors.response.use(
  res => responseDataDecode(res),
  error => Promise.reject(error)
);

export default async function cgRequest(
  map: UrlMap,
  method: "GET" | "POST",
  params: object = {},
  extra: any = {}
) {
  try {
    const data: CgRequestParams = {
      url: map.url,
      method,
      params,
      extra_data: {
        encrypt_body: true,
        ...extra
      }
    };
    const requestData: any = await addDefaultParamsAndEncrypt(data);
    const result = await http.request(requestData);
    // 如果有name，需要打点

    return Promise.resolve(result);
  } catch (e) {
    // 如果有name，需要打点
    return Promise.reject(e);
  }
}
